import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Calendar = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3.75 9.75h16.5m-12.5-5v-2m8.5 2v-2m-10.5 17.5h12.5a2 2 0 0 0 2-2V6.75a2 2 0 0 0-2-2H5.75a2 2 0 0 0-2 2v11.5a2 2 0 0 0 2 2'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect x='7' y='12' width='2' height='2' rx='0.5' fill='currentColor' />
        <rect x='7' y='16' width='2' height='2' rx='0.5' fill='currentColor' />
        <rect x='11' y='12' width='2' height='2' rx='0.5' fill='currentColor' />
        <rect x='11' y='16' width='2' height='2' rx='0.5' fill='currentColor' />
        <rect x='15' y='12' width='2' height='2' rx='0.5' fill='currentColor' />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.5 2.75a.75.75 0 0 0-1.5 0V4H5.75A2.75 2.75 0 0 0 3 6.75v11.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V6.75A2.75 2.75 0 0 0 18.25 4H17V2.75a.75.75 0 0 0-1.5 0V4h-7zm-4 4c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V9h-15zM7 12.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3.5-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3.5-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
